// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Legend_wrapper__3KpLY","item":"Legend_item__35BOM","text":"Legend_text__19tfu"};